<div class="sales-orders-table">
  <sales-ui-sales-order-table-stats *ngIf="showStats" [dataService]="dataService"></sales-ui-sales-order-table-stats>
  <div>
    <va-filtered-mat-table
      [presetJSON]="presetViews"
      [tableDataService]="dataService"
      [limitContentHeightForDesktop]="false"
      (customExportEvent)="handleCustomExportEvent($event)"
    ></va-filtered-mat-table>
  </div>
</div>
